module.exports = __webpack_public_path__ + "arrow_left_shape_clamp_white.597d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/arrow_left_shape_clamp_white.svg
// module id = ./src/_asset/sources/assets/images/@svg/arrow_left_shape_clamp_white.svg
// module chunks = main